import { momentZone } from './datetime'

// Скачивание файлов из SPA: presigned-ссылки живут на другом origin
// (s3.<domain>), где атрибут download игнорируется браузером — поэтому байты
// забираются fetch'ем и отдаются как blob с нашим именем файла.

export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.rel = 'noopener'
  a.click()
  // Отложенный revoke: немедленный обрывает начатое скачивание в Firefox.
  setTimeout(() => URL.revokeObjectURL(url), 30_000)
}

export function downloadTextFile(filename: string, content: string, mime = 'text/plain'): void {
  saveBlob(new Blob([content], { type: `${mime};charset=utf-8` }), filename)
}

export async function downloadFromUrl(url: string, filename: string): Promise<void> {
  const res = await fetch(url)
  if (!res.ok) throw new Error(`download: HTTP ${res.status}`)
  saveBlob(await res.blob(), filename)
}

// Имя файла из ключа объекта в URL (последний сегмент пути, без query).
export function filenameFromUrl(url: string, fallback: string): string {
  try {
    const last = new URL(url).pathname.split('/').filter(Boolean).pop()
    return last ? decodeURIComponent(last) : fallback
  } catch {
    return fallback
  }
}

// Человекочитаемое имя скачиваемого файла: «Название — 08.07.2026 (запись голоса).ogg».
// Символы, запрещённые в файловых системах, вычищаются; длинное название обрезается.
// День берётся в зоне устройства — тот же, что смотрящий видит у встречи на
// экране: имя файла обязано совпасть с датой в списке, из которого его качают.
export function downloadFilename(
  title: string,
  dateIso: string,
  label: string,
  ext: string,
  tz: string = momentZone(),
): string {
  const safeTitle =
    title
      .replace(/[/\\:*?"<>|]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, 80)
      .trim() || 'встреча'
  const parsed = new Date(dateIso)
  const date = Number.isNaN(parsed.getTime())
    ? ''
    : new Intl.DateTimeFormat('ru-RU', {
        timeZone: tz,
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      }).format(parsed)
  return `${safeTitle}${date ? ` — ${date}` : ''} (${label}).${ext}`
}
